import Vue from 'vue'
import Vuex from 'vuex'
import agents from './modules/agents'
import messages from './modules/messages'
import alerts from './modules/alerts'
import docs from './modules/docs'
import currencies from './modules/currencies'

// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    agents,
    messages,
    alerts,
    docs,
    currencies,
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})

if (module.hot) {
  // рассматриваем действия и мутации как модули для горячей замены
  module.hot.accept(['./modules/agents'], () => {
    // запрашиваем обновлённые модули
    // (нужно указать .default из-за формата вывода Babel 6)
    // const newMutations = require('./mutations').default;

    const AgentsModule = require('./modules/agents').default;
    const MessagesModule = require('./modules/messages').default;
    const AlertsModule = require('./modules/alerts').default;
    const DocsModule = require('./modules/docs').default;
    const CurrenciesModule = require('./modules/currencies').default;
    // заменяем на новые модули и мутации
    store.hotUpdate({
      // mutations: newMutations,
      modules: {
        agents: AgentsModule,
        messages: MessagesModule,
        alerts: AlertsModule,
        docs: DocsModule,
        currencies: CurrenciesModule,
      }
    })
  })
}